<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Id'), sort: 'Id' },
              { title: $t('RequesterName'), sort: 'RequesterName' },
              { title: $t('Departman'), sort: 'Departman' },
              { title: $t('DeliveryDate'), sort: 'DeliveryDate' },
              { title: $t('CreationDate'), sort: 'CreationDate' },
              { title: $t('Description'), sort: 'Description' },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td>
                {{ row.id }}
              </td>
              <td>
                {{ row.requesterInfo ? row.requesterInfo.name : "-" }}
              </td>
              <td>
                {{ row.departmentUnit ? row.departmentUnit.name : "-" }}
              </td>
              <td>
                {{ row.persianDeliveryClock ? row.persianDeliveryClock : "-" }}
              </td>
              <td>
                {{ row.persianCreateOn ? row.persianCreateOn : "-" }}
              </td>
              <td>
                {{ row.description ? row.description : "-" }}
              </td>
              <td>
                <router-link
                  v-has-permission="'GetPurchaseOrderById'"
                  :to="
                    '/ProcurementManagement/PurchaseRequest/ShowDetails' +
                    '/' +
                    row.id
                  "
                >
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="d-inline"
                  ></vs-button>
                </router-link>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  components: {
    DataGrid,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "Procurements/api/PurchaseRequestsQuery",
      },
      gridSearchData: {},
    };
  },
  methods: {
    editPurchaseRequest(model) {},
    deletePurchaseRequest(id) {},
  },
};
</script>
